(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gallery-block')) {
    class GalleryBlock extends HTMLElement {
      connectedCallback() {
        if (this._init) return;
        this._init = true;

        this.list = this.querySelector('[data-gb-list]');
        this.items = Array.from(this.querySelectorAll('[data-gb-item]'));
        this.moreBtn = this.querySelector('[data-gb-more]');
        this.prevBtn = this.querySelector('[data-gb-prev]');
        this.nextBtn = this.querySelector('[data-gb-next]');
        this.dialog = this.querySelector('[data-gb-dialog]');

        this.initial = parseInt(this.dataset.initial, 10) || 0;
        this.step = parseInt(this.dataset.step, 10) || this.initial || 8;
        this.shown = this.initial;
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        if (this.moreBtn) this.moreBtn.addEventListener('click', () => this.loadMore());
        if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.scrollSlides(-1));
        if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.scrollSlides(1));
        if (this.list && this.prevBtn) {
          this.list.addEventListener('scroll', () => requestAnimationFrame(() => this.updateArrows()), { passive: true });
          window.addEventListener('resize', (this._onResize = () => this.updateArrows()));
        }

        if (this.dialog) this.setupLightbox();
        this.render();
        this.setupEntrance();
      }

      disconnectedCallback() {
        if (this.io) this.io.disconnect();
        if (this._onResize) window.removeEventListener('resize', this._onResize);
        document.documentElement.style.overflow = '';
        this._init = false;
      }

      /* ---------- Load more ---------- */
      render() {
        const limit = this.initial ? this.shown : Infinity;
        this.items.forEach((el, idx) => { el.hidden = idx >= limit; });
        if (this.moreBtn) this.moreBtn.hidden = this.items.length <= limit;
        this.updateArrows();
      }

      loadMore() {
        const previous = this.shown;
        this.shown += this.step;
        this.render();
        const first = this.items[previous];
        const focusable = first && first.querySelector('button');
        if (focusable) focusable.focus();
      }

      /* ---------- Carousel ---------- */
      scrollSlides(direction) {
        const first = this.items.find((el) => !el.hidden);
        if (!first) return;
        const gap = parseFloat(getComputedStyle(this.list).columnGap) || 0;
        const slideWidth = first.getBoundingClientRect().width + gap;
        const perPage = Math.max(1, Math.floor(this.list.clientWidth / slideWidth));
        this.list.scrollBy({ left: direction * slideWidth * perPage, behavior: this.reduceMotion ? 'auto' : 'smooth' });
      }

      updateArrows() {
        if (!this.prevBtn || !this.nextBtn || !this.list) return;
        const l = this.list;
        this.prevBtn.disabled = l.scrollLeft <= 1;
        this.nextBtn.disabled = l.scrollLeft + l.clientWidth >= l.scrollWidth - 1;
      }

      /* ---------- Entrance animation ---------- */
      setupEntrance() {
        const type = this.dataset.entrance;
        if (!type || type === 'none' || this.reduceMotion || !('IntersectionObserver' in window)) return;
        this.classList.add('is-animated');
        this.io = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                entry.target.classList.add('is-visible');
                this.io.unobserve(entry.target);
              }
            });
          },
          { rootMargin: '0px 0px -8% 0px' }
        );
        this.items.forEach((el) => this.io.observe(el));
      }

      /* ---------- Lightbox ---------- */
      setupLightbox() {
        const d = this.dialog;
        this.lbImg = d.querySelector('[data-gb-lb-img]');
        this.lbCaption = d.querySelector('[data-gb-lb-caption]');
        this.lbCounter = d.querySelector('[data-gb-counter]');
        this.lbPrev = d.querySelector('[data-gb-lb-prev]');
        this.lbNext = d.querySelector('[data-gb-lb-next]');
        const figure = d.querySelector('[data-gb-lb-figure]');
        const stage = d.querySelector('[data-gb-stage]');

        this.addEventListener('click', (e) => {
          const trigger = e.target.closest('[data-gb-open]');
          if (!trigger) return;
          e.preventDefault();
          this.openLightbox(trigger.closest('[data-gb-item]'));
        });

        d.querySelector('[data-gb-close]').addEventListener('click', () => d.close());
        this.lbPrev.addEventListener('click', () => this.showSlide(-1));
        this.lbNext.addEventListener('click', () => this.showSlide(1));

        d.addEventListener('click', (e) => {
          if (e.target === d || e.target === stage) d.close();
        });
        d.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowLeft') this.showSlide(-1);
          if (e.key === 'ArrowRight') this.showSlide(1);
        });
        d.addEventListener('close', () => {
          document.documentElement.style.overflow = '';
          this.lbImg.removeAttribute('src');
        });

        // Swipe
        let startX = null;
        figure.addEventListener('pointerdown', (e) => { startX = e.clientX; });
        figure.addEventListener('pointerup', (e) => {
          if (startX === null) return;
          const dx = e.clientX - startX;
          startX = null;
          if (Math.abs(dx) > 50) this.showSlide(dx < 0 ? 1 : -1);
        });
        figure.addEventListener('pointercancel', () => { startX = null; });
      }

      openLightbox(item) {
        this.lbItems = this.items.filter((el) => !el.hidden && el.querySelector('[data-gb-open]'));
        this.lbIndex = this.lbItems.indexOf(item);
        if (this.lbIndex < 0) return;
        this.showSlide(0);
        if (typeof this.dialog.showModal === 'function') this.dialog.showModal();
        else this.dialog.setAttribute('open', '');
        document.documentElement.style.overflow = 'hidden';
      }

      showSlide(delta) {
        const total = this.lbItems.length;
        if (!total) return;
        this.lbIndex = (this.lbIndex + delta + total) % total;
        const data = this.lbItems[this.lbIndex].querySelector('[data-gb-open]').dataset;

        this.lbImg.src = data.full;
        this.lbImg.alt = data.alt || '';

        const showCaption = this.dataset.captions === 'true' && data.caption;
        this.lbCaption.textContent = showCaption ? data.caption : '';
        this.lbCaption.hidden = !showCaption;

        if (this.lbCounter) this.lbCounter.textContent = `${this.lbIndex + 1} / ${total}`;
        this.lbPrev.hidden = this.lbNext.hidden = total < 2;

        [1, -1].forEach((step) => {
          const neighbour = this.lbItems[(this.lbIndex + step + total) % total];
          const src = neighbour && neighbour.querySelector('[data-gb-open]').dataset.full;
          if (src) new Image().src = src;
        });
      }
    }
    customElements.define('gallery-block', GalleryBlock);
  }
  } catch(e) { console.error(e); }
})();

})();
